import React, { useMemo } from "react";
import EventLabel from "../../../components/EventLabel";

export const VoucherRow = ({ breakout, voucher, langCode, usedVouchers, navigateToForm, showAltName }) => {
  const { exhibitorVoucherId, count, eventId } = voucher;
  const name = useMemo(() => {
    const lang = breakout.eventDisplayLanguage?.find(edl=> edl.languageCode == langCode && edl.alternative == showAltName)
    return lang?.name || breakout.name;
  }, [breakout]);
  return (
    <tr>
      <td>{name}</td>
      <td style={{ textAlign: "right" }}>{usedVouchers[exhibitorVoucherId] ?? 0}</td>
      <td style={{ textAlign: "right" }}>{count < 1 ? "X" : count}</td>
      <td style={{ textAlign: "right" }}>{eventId === 3628 || eventId === 3265 || eventId === 3721 ? "X" : (usedVouchers[exhibitorVoucherId] ?? 0) > count ? (usedVouchers[exhibitorVoucherId] ?? 0) - count : 0}</td>
      <td style={{ textAlign: "center" }}>
        {voucher.contentLayoutCode ? (
          <button onClick={() => navigateToForm(voucher)} className="cms-button">
            <EventLabel name="OpenButton" groupName="CMS.Voucher" />
          </button>
        ) : null}
      </td>
    </tr>
  );
};
